import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FaBars, FaTimes, FaPhoneAlt, FaWhatsapp, FaMapMarkerAlt } from 'react-icons/fa';
import logo from "../assets/images/logo-slogan.png";

const TopBar = styled.div`
  width: 100%;
  background: var(--primary-blue);
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 36px;
  font-size: 1rem;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 20;
  transition: top 0.3s;
  @media screen and (max-width: 600px) {
    font-size: 0.9rem;
    height: 44px;
    flex-direction: column;
    padding: 4px 0;
     height: 32px;
  }
`;

const TopBarContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  width: 100%;

  @media screen and (max-width: 600px) {
    justify-content: space-around;
    font-size: 12px;

  }
`;

const TopBarLink = styled.a`
  color: #fff;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 500;
  transition: color 0.2s;
  &:hover {
    color: var(--primary-green);
  }
`;

const Nav = styled.nav`
  background: ${({ scrolled }) => (scrolled ? '#1A365D' : 'transparent')};
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
  position: fixed;
  top: ${({ style }) => style?.top || '0'};
  width: 100%;
  z-index: 10;
  transition: all 0.3s ease-in-out;
  box-shadow: ${({ scrolled }) => (scrolled ? '0 2px 10px rgba(0, 0, 0, 0.1)' : 'none')};
`;

const NavbarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 1300px;
  padding: 0 50px;

  @media screen and (max-width: 960px) {
    padding: 0 30px;
  }
`;

const NavLogo = styled(Link)`
  color: #fff;
  justify-self: flex-start;
  cursor: pointer;
  text-decoration: none;
  font-size: 1.5rem;
  display: flex;
  align-items: center;
  font-weight: bold;
  
  img {
    height: 50px;
  }
`;

const MobileIcon = styled.div`
  display: none;

  @media screen and (max-width: 960px) {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(-100%, 60%);
    font-size: 1.8rem;
    cursor: pointer;
    color: #fff;
  }
`;

const NavMenu = styled.ul`
  display: flex;
  align-items: center;
  list-style: none;
  text-align: center;

  @media screen and (max-width: 960px) {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 90vh;
    position: absolute;
    top: 80px;
    left: ${({ isOpen }) => (isOpen ? '0' : '-100%')};
    opacity: 1;
    transition: all 0.5s ease;
    background: #1A365D;
  }
`;

const NavItem = styled.li`
  height: 80px;

  @media screen and (max-width: 960px) {
    width: 100%;
    height: auto;
  }
`;

const StyledNavLinks = styled(Link)`
  color: #fff;
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 0.5rem 1rem;
  height: 100%;
  font-family: 'Open Sans', sans-serif;
  position: relative;
  &:after {
    content: '';
    position: absolute;
    width: 0;
    height: 3px;
    bottom: 15px;
    left: 50%;
    background-color: #4CAF50;
    transition: all 0.3s ease;
    transform: translateX(-50%);
  }
  &:hover:after {
    width: 70%;
  }
  @media screen and (max-width: 960px) {
    text-align: center;
    padding: 2rem;
    width: 100%;
    display: table;
    &:hover {
      color: #4CAF50;
      transition: all 0.3s ease;
    }
    &:after {
      display: none;
    }
  }
`;

const NavLinks = ({ to, children, onClick, ...rest }) => {

  return (
    <StyledNavLinks
      to={to}
      onClick={onClick}
      {...rest}
    >
      {children}
    </StyledNavLinks>
  );
};

const NavButton = styled(Link)`
  background: #4CAF50;
  white-space: nowrap;
  padding: 10px 22px;
  color: #fff;
  font-size: 16px;
  outline: none;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  border-radius: 4px;
  margin-left: 20px;
  font-weight: bold;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: #fff;
    color: #4CAF50;
  }

  @media screen and (max-width: 960px) {
    width: 80%;
    margin: 20px auto;
    text-align: center;
  }
`;

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [hideTopBar, setHideTopBar] = useState(false);
  const location = useLocation();

  const isHome = location.pathname === '/';

  const handleScroll = () => {
    if (window.scrollY > 0) {
      setScrolled(true);
      setHideTopBar(true);
    } else {
      setScrolled(false);
      setHideTopBar(false);
    }
  };

  useEffect(() => {
    if (!isHome) {
      setHideTopBar(true);
    }
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isHome]);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  const navTop = isHome && !hideTopBar ? '36px' : '0';

  return (
    <>
      {isHome && !hideTopBar && (
        <TopBar>
          <TopBarContent>
            <TopBarLink href="https://wa.me/555535121297" target="_blank" rel="noopener noreferrer">
              <FaWhatsapp /> (55) 3512 1297
            </TopBarLink>
            <TopBarLink href="#" target="_blank" rel="noopener noreferrer" className="hide-mobile">
              <FaMapMarkerAlt /> ERS 162, N 2191, Bairro Auxiliadora - Santa Rosa - RS
            </TopBarLink>
            <TopBarLink href="tel:+5535122727" target="_blank" rel="noopener noreferrer">
              <FaPhoneAlt /> (55) 3512 2727
            </TopBarLink>
          </TopBarContent>
        </TopBar>
      )}
      <Nav scrolled={scrolled || !isHome} style={{ top: navTop }}>
        <NavbarContainer>
          <NavLogo to="/">
            <img src={logo} alt="Memorial Crematório Dom José" />
          </NavLogo>
          <MobileIcon onClick={toggle}>
            {isOpen ? <FaTimes /> : <FaBars />}
          </MobileIcon>
          <NavMenu isOpen={isOpen}>
            <NavItem>
              <NavLinks to="/#about" onClick={() => setIsOpen(false)}>Sobre</NavLinks>
            </NavItem>
            <NavItem>
              <NavLinks to="/#funeraria" onClick={() => setIsOpen(false)}>Funerária</NavLinks>
            </NavItem>
            {/*<NavItem>
              <NavLinks to="/estrutura" onClick={() => setIsOpen(false)}>Estrutura</NavLinks>
            </NavItem>*/}
            <NavItem>
              <NavLinks to="/cremacao" onClick={() => setIsOpen(false)}>Cremação</NavLinks>
            </NavItem>
            <NavItem>
              <NavLinks to="/cemiterios" onClick={() => setIsOpen(false)}>Cemitérios</NavLinks>
            </NavItem>
            <NavItem>
              <NavLinks to="/planos" onClick={() => setIsOpen(false)}>Planos</NavLinks>
            </NavItem>
            <NavItem>
              <NavLinks to="/#contact" onClick={() => setIsOpen(false)}>Contato</NavLinks>
            </NavItem>
            <NavButton to="/velorio-online" onClick={() => setIsOpen(false)}>Velório Online</NavButton>
          </NavMenu>
        </NavbarContainer>
      </Nav>
    </>
  );
};

export default Navbar;
